/*
 *
 * LeadersSummary constants
 *
 */

export const GET_LEADERS_SUMMARY_WATCHER =
  "app/LeadersSummary/GET_LEADERS_SUMMARY_WATCHER"
export const GET_LEADERS_SUMMARY_SUCCESS =
  "app/LeadersSummary/GET_LEADERS_SUMMARY_SUCCESS"
export const GET_LEADERS_SUMMARY_FAILED =
  "app/LeadersSummary/GET_LEADERS_SUMMARY_FAILED"

export const UPLOAD_TEMPLATE_LEADERS_WATCHER =
  "app/LeadersSummary/UPLOAD_TEMPLATE_LEADERS_WATCHER"
export const UPLOAD_TEMPLATE_LEADERS_SUCCESS =
  "app/LeadersSummary/UPLOAD_TEMPLATE_LEADERS_SUCCESS"
export const UPLOAD_TEMPLATE_LEADERS_FAILED =
  "app/LeadersSummary/UPLOAD_TEMPLATE_LEADERS_FAILED"

export const SAVE_EXCEL_LEADERS_WATCHER =
  "app/LeadersSummary/SAVE_EXCEL_LEADERS_WATCHER"
export const SAVE_EXCEL_LEADERS_SUCCESS =
  "app/LeadersSummary/SAVE_EXCEL_LEADERS_SUCCESS"
export const SAVE_EXCEL_LEADERS_FAILED =
  "app/LeadersSummary/SAVE_EXCEL_LEADERS_FAILED"
export const SAVE_EXCEL_LEADERS_PROGRESS =
  "app/LeadersSummary/SAVE_EXCEL_LEADERS_PROGRESS"
